import { createSlice } from '@reduxjs/toolkit';
import type { GraphViewState } from './types';

const initialState: GraphViewState = {
  isLoading: false,
  error: false,
  pathways: []
};

export const slice = createSlice({
  name: 'personalGraph',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    hasError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    fetchGraphPathwaysSuccess(state, action) {
      state.isLoading = false;
      state.pathways = action.payload.items ?? [];
    }
  }
});

export default slice.reducer;
